<div
  class="min-h-screen w-full bg-gray-200 flex flex-col zoomoutsmall overflow-auto"
>
  <!--Blur Background  -->

  <div class="fixed inset-0">
    <div
      class="animcircle rounded-full filter blur-[100px] absolute w-[50%] bg-primary aspect-square bg-rad top-[-25%] right-[-23%] opacity-40"
    ></div>
  </div>

  <header class="onboard-header">
    <div class="onboard-header-inner">
      <a class="onboard-brand" routerLink="/onboarding" aria-label="SigmaT Conflux">
        <img [src]="headerLogo" alt="SigmaT Conflux" />
      </a>

      <nav class="onboard-header-actions" aria-label="Support">
        <button type="button" class="header-chip header-chip-primary" (click)="loadCalendly()">
          <img src="../../assets/image/demo.svg" alt="" />
          <span>Schedule Demo</span>
        </button>
        <a class="header-chip" [href]="supportPhoneHref">
          <img src="../../assets/image/call.svg" alt="" />
          <span>{{ supportContactNumber }}</span>
        </a>
        <a class="header-chip" [href]="'mailto:' + supportContactEmail">
          <img src="../../assets/image/Shape.svg" alt="" />
          <span>{{ supportContactEmail }}</span>
        </a>
        <a class="header-login" routerLink="/">Login</a>
      </nav>
    </div>
  </header>

  <div class="relative flex flex-col items-center justify-center overflow-x-hidden overflow-y-visible" style=" background-image: url(https://honeywell.scene7.com/is/image/honeywell/commercial-building-solutions-honeywell-1:5-2-hero); background-repeat: round;">
    <!-- Decorative Image -->
    <img *ngIf="false"
      src="../../assets/image/splash.png"
      alt="Sigma Infra"
      class="absolute -bottom-40 -left-32 w-60 opacity-20 select-none pointer-events-none"
    />
  
    <!-- Main Content Wrapper -->
    <div class="flex flex-col lg:flex-row items-center lg:items-start justify-between w-full max-w-7xl px-6 md:px-12 py-8 gap-8 z-10" >
      
      <!-- Left Content -->
      <div class="flex-1 text-center lg:text-left space-y-6 lg:pt-16">
        <h1 class="text-3xl md:text-5xl font-extrabold text-white">SigmaTConFlux™</h1>
        <p class="text-xl md:text-2xl font-medium text-white">
          The most modern project governance tool
        </p>
      </div>
  
      <!-- Right Side Form Card -->
      <div class="w-full shrink-0" [class.max-w-2xl]="!isCompactAuthCard" [class.max-w-md]="isCompactAuthCard">
        <div class="bg-white rounded-2xl shadow-2xl px-4 md:px-8 py-4 border-l-4 border-primary min-w-0 w-full">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  
  
  <div class="h-[80px]"></div>
  <app-footer class="fixed bottom-0 w-full z-40 bg-primary"></app-footer>
</div>
</div>